import React from 'react';
import PropTypes from 'prop-types';

function TaskIcon({ id }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 91 91"
      version="1.1"
      viewBox="0 0 91 91"
      xmlSpace="preserve"
      role="img"
      aria-labelledby="task-icon-title"
    >
      <title id="task-icon-title">Task Icon</title>
      <g>
        <g transform="translate(6 4)">
          <g>
            <linearGradient
              id={`path-2_2_${id}`}
              x1="-429.125"
              x2="-429.125"
              y1="316.824"
              y2="315.004"
              gradientTransform="matrix(50 0 0 -50 21495.723 15837.2)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" className="startColor" />
              <stop offset="1" className="endColor" />
            </linearGradient>
            <circle
              cx="39.5"
              cy="41.5"
              r="45.5"
              fill={`url(#path-2_2_${id})`}
            />
          </g>
          <g transform="translate(13 9)">
            <g>
              <g>
                <g>
                  <path
                    fill="#ACB3BA"
                    d="M48 9H7.2c-1.3 0-2.4 1.1-2.4 2.4v47.8c0 1.3 1.1 2.4 2.4 2.4h40.9c1.3 0 2.4-1.1 2.4-2.4V11.4C50.4 10.1 49.4 9 48 9z"
                  />
                  <path
                    fill="#F2F2F2"
                    d="M46.7 14.4c0-1-.8-1.8-1.8-1.8H10.2c-1 0-1.8.8-1.8 1.8v41.7c0 1 .8 1.8 1.8 1.8h29.5l7.2-7.2V14.4h-.2z"
                  />
                  <path
                    fill="#CDD6E0"
                    d="M46.7 50.8h-5.3c-1 0-1.8.8-1.8 1.8V58l7.1-7.2z"
                  />
                  <path
                    fill="#40596B"
                    d="M37 6.7h-5.1c-.5-1.8-2.3-3.3-4.4-3.3-2.1 0-3.9 1.5-4.4 3.3H18c-1.3 0-2.4 1.1-2.4 2.4v5.5h23.8V9.1c.1-1.4-1-2.4-2.4-2.4z"
                  />
                  <path fill="#CDD6E0" d="M20.8 24.1H33.7V26.5H20.8z" />
                  <path fill="#ACB3BA" d="M20.8 31.5H44.2V33.9H20.8z" />
                  <path fill="#CDD6E0" d="M20.8 36.6H33.7V39H20.8z" />
                  <g fill="#ACB3BA" transform="translate(8.813 8.625)">
                    <path d="M12 10.5H35.4V12.9H12z" />
                    <path d="M12 35.4H35.4V37.8H12z" />
                  </g>
                  <path fill="#CDD6E0" d="M20.8 49H33.7V51.4H20.8z" />
                  <g fill="#FF7058" transform="translate(3.375 8.625)">
                    <path d="M7.5 10.5H14.9V17.9H7.5z" />
                    <path d="M7.5 23H14.9V30.4H7.5z" />
                    <path d="M7.5 35.4H14.9V42.8H7.5z" />
                  </g>
                  <g fill="#FFF" transform="translate(3.75 9.313)">
                    <path d="M10 16L7.8 13.8 8.9 12.8 10 13.7 12.7 11.1 13.8 12.1z" />
                    <path d="M10 28.4L7.8 26.3 8.9 25.1 10 26.2 12.7 23.4 13.8 24.6z" />
                    <path d="M10 40.9L7.8 38.7 8.9 37.6 10 38.6 12.7 35.9 13.8 37z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

TaskIcon.propTypes = {
  id: PropTypes.string,
};

TaskIcon.defaultProps = {
  id: '',
};

export default React.memo(TaskIcon);
